import { useSelector } from 'react-redux';
import { getMiniplayerPlaybackConfig } from 'react/reducers/selectors/metadata';

export const useMiniplayerPlaybackConfig = () =>
  useSelector(getMiniplayerPlaybackConfig);
